module.exports = "<div class=\"gw-radios-binary\">\n    <div class=\"gw-switcher\"></div>\n\n    <div class=\"gw-labels\">\n        <label class=\"gw-first\" for=\"{{::inputId1}}\" ng-attr-title=\"{{title1}}\">\n        </label>\n        <label class=\"gw-second\" for=\"{{::inputId2}}\" ng-attr-title=\"{{title2}}\">\n        </label>\n    </div>\n\n    <label class=\"gw-overlap1\" for=\"{{::inputId1}}\"></label>\n    <label class=\"gw-overlap2\" for=\"{{::inputId2}}\"></label>\n</div>"


//////////////////
// WEBPACK FOOTER
// ../common/grunt/webpack/loaders/text-loader!../common/js/src/edge/platform/atomic_design/molecules/directives/templates/radios-binary.html
// module id = 452
// module chunks = 0